import styled from "styled-components";
import { Props as PageContainerProps } from "./PageContainer";

export const Container = styled.div<PageContainerProps>`
  overflow-y: auto;
  overflow-x: hidden;
`;
